<div class="bg col-12 position-relative py-5 py-md-0 position-relative">
  <img
    class="d-none d-xl-block img-person position-absolute bottom-0 w-100"
    lazyLoad="/img/image-phone-download.png"
    alt="Phone Download"
  />

  <img
    class="position-absolute bottom-0 end-0 mw-100"
    lazyLoad="/img/image-person-download.png"
    alt="Person download"
  />

  @let localHome = home();
  <div
    class="position-absolute bottom-0 end-0 z-1 text-end dark-blue-text"
    style="max-width: 450px"
  >
    <app-banner-app-downloads
      classesContent="pt-3 ps-4 pe-3 ps-sm-5"
      [title]="'$title_banner_download_apps' | translate"
      [imageAndroid]="localHome?.home?.language?.banner_image_android"
      [imageIos]="localHome?.home?.language?.banner_image_ios"
      imageBackground="/img/image-apps-download.png"
      (clickAndroidChange)="goToUrl(localHome?.home?.language?.banner_url_android)"
      (clickIosChange)="goToUrl(localHome?.home?.language?.banner_url_ios)"
    />
  </div>

  <div class="content-info row h-100 position-relative">
    <div
      class="col-12 col-lg-6 col-xxl-5 d-flex flex-column align-items-center justify-content-center text-center align-items-md-start text-md-start text-white"
    >
      <h2 class="mb-4 text-center ms-lg-5 text-lg-start stroke w-100">
        <span class="stroke__outline">{{ 'title_section_unique_experiences' | translate }}</span>
        <span class="stroke__fill">{{ 'title_section_unique_experiences' | translate }}</span>
      </h2>

      <ul
        class="list-style-none mb-0 dark-blue-text d-flex ps-0 flex-column align-items-center align-items-lg-start d-lg-block"
      >
        <li class="my-2 my-lg-3 rounded-end-4 py-2 px-5 bg-blue-light">
          {{ 'description_item1_experiences' | translate }}
        </li>
        <li class="my-2 my-lg-3 rounded-end-4 py-2 px-5 bg-yellow-light">
          {{ 'description_item2_experiences' | translate }}
        </li>
        <li class="my-2 my-lg-3 rounded-end-4 py-2 px-5 bg-red-light">
          {{ 'description_item3_experiences' | translate }}
        </li>
        <li class="my-2 my-lg-3 rounded-end-4 py-2 px-5 bg-light">
          {{ 'description_item4_experiences' | translate }}
        </li>
      </ul>
    </div>
  </div>
</div>
